var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_40",
    "data-name": "Grupo 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.276,
    height: 150.778,
    viewBox: "0 0 151.276 150.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_87",
    "data-name": "Ret\\xE2ngulo 87",
    width: 151.276,
    height: 150.778,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M55.133,18.281A50.058,50.058,0,0,0,14.572,32.357,48.654,48.654,0,0,0,1.25,56.154c4.033,3.641,8.091,7.388,12.157,11.19Z",
    transform: "translate(2.154 31.008)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M69.794,33.747l-50.8,42.045q6.5,6.736,12.718,13.426a49.733,49.733,0,0,0,24.126-13.14A48.59,48.59,0,0,0,69.794,33.747Z",
    transform: "translate(32.732 58.156)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M10.73,81.667l37.129,36.626,54.477-45.081A74.122,74.122,0,0,0,128.145,2.468a76.287,76.287,0,0,0-71.713,25.46Z",
    transform: "translate(18.491 2.153)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M36.827,62.991c-5.7,5.624-34.412,13.578-34.412,13.578-.381.379,8.064-28.322,13.766-33.946a14.736,14.736,0,0,1,20.645,0,14.26,14.26,0,0,1,0,20.368",
    transform: "translate(4.142 66.181)",
    fill: "#b1ed5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M59.11,19.516a127.252,127.252,0,0,1,15.248,18.1A74.138,74.138,0,0,0,76.4,2.463a77.128,77.128,0,0,0-35.64,2.013A128.183,128.183,0,0,1,59.11,19.516Z",
    transform: "translate(70.238 2.161)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M62.485,38.206a17.2,17.2,0,0,1-24.09,0,16.641,16.641,0,0,1,0-23.764,17.2,17.2,0,0,1,24.09,0,16.651,16.651,0,0,1,0,23.764",
    transform: "translate(57.566 16.407)",
    fill: "#b1ed5e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_12",
    "data-name": "Linha 12",
    x2: 39.128,
    y2: 38.597,
    transform: "translate(39.632 71.58)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.e59db7837a349c1ce896a277724ddfcb.svg";
export { ForwardRef as ReactComponent };